module.exports = __webpack_public_path__ + "img/swiper1.67452f4a.png";